import moment from 'moment-timezone';
import { get, isEmpty } from 'lodash';
import { buildTimeseriesQuery, formatQueryStatus } from './utils';
import { getDimensionData } from '@api/dimensionContainer';
import instance from '@api/axiosInstance';
import { NETWORK_REQUEST_RESPONSE_CODE_DIMENSION } from '../constants';
import { trackQueryError } from '@utils/sensor/apptracker';
import useQueryParams from '@src/components/widget-panel/hooks/useQueryParams';
import { useMemo } from 'react';
import { getCodeColorMap, getStackedTimeSeries } from '../utils';
import useWidgetQuery from '@src/components/widget-panel/hooks/useWidgetQuery';
export const AVERAGE_REQUEST_COUNT_METRIC = 'AverageRequestCount';

function useResponseTimeseries({ wid, metrics, filters, enabled = true }: any) {
  const { interval, filter: globalFilter, _rKey, liveMode } = useQueryParams();
  const filter = filters.length ? [...globalFilter, filters] : globalFilter;

  const query: any = buildTimeseriesQuery({
    metrics,
    filter,
    interval: `${moment(interval.from).format()}/${moment(interval.to).format()}`,
    granularity: interval.granularity,
  });
  query.groupBy = [NETWORK_REQUEST_RESPONSE_CODE_DIMENSION];
  query.options.stacked = { metric: NETWORK_REQUEST_RESPONSE_CODE_DIMENSION };
  const { data, ...queryStatus } = useWidgetQuery({
    wid,
    queryKey: ['widget', 'network-code', query],
    queryFn: () => {
      return getDimensionData({ queries: [query] }, {}, instance).then((response) =>
        get(response, ['data', 0, 'data'], []),
      );
    },
    options: {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: enabled && !liveMode,
      staleTime: 5 * 60 * 1000, // 5m
      onError: (err) => {
        trackQueryError({ type: 'app-network-code', err });
      },
    },
  });

  const chartData = useMemo(() => {
    if (isEmpty(data)) {
      return undefined;
    }
    const codes = filters.map(({ value: code }) => code).reverse();
    const colorMap = getCodeColorMap(codes);
    return getStackedTimeSeries({
      data,
      series: codes,
      colorMap,
      groupBy: NETWORK_REQUEST_RESPONSE_CODE_DIMENSION,
      metric: AVERAGE_REQUEST_COUNT_METRIC,
      interval,
    });
  }, [interval, data, filters]);

  return {
    ...formatQueryStatus({ ...queryStatus, isEmpty: isEmpty(data) }),
    data: chartData,
    interval,
  };
}

export default useResponseTimeseries;
